// extracted by mini-css-extract-plugin
export default {"a":"GOXCrkze","large":"RJYH_P_h","small":"tsVX5uaK","small-display":"mJf6H7ww","xsmall":"NFx633Z0"};